import React from "react";

export default function ClozeStoryResults({ correctCount, incorrectCount, score, onPlayAgain }) {
  const stats = [
    { label: "Score", value: score },
    { label: "Correct", value: correctCount },
    { label: "Incorrect", value: incorrectCount }
  ];

  return (
    <div className="cloze-story-results" data-testid="cloze-story-results">
      <h2 className="joystix">Story complete!</h2>
      <div className="cloze-story-results-stats">
        {stats.map((stat) => (
          <div key={stat.label}>
            <strong>{stat.value}</strong>
            <span>{stat.label}</span>
          </div>
        ))}
      </div>
      {!!onPlayAgain && (
        <button className="btn btn-success btn-lg btn-block" data-testid="cloze-story-play-again" type="button" onClick={onPlayAgain}>
          <span className="fa fa-repeat" /> Play again
        </button>
      )}
    </div>
  );
}
